import React, {lazy, Suspense} from "react"
import {Redirect, Route, Router, Switch} from "react-router-dom"
import {history} from "./history"
import {connect} from "react-redux"
import Spinner from "./components/loader/spinner"
import {ContextLayout} from "./utility/context/Layout"
import {store} from "./redux/storeConfig/store";
import {getPing} from "./redux/actions/auth/pingActions";
import {getUI} from "./redux/actions/UI/uiActions";
import FaqsIndex from "./views/panel/FaqsIndex";
import ContactusManagement from './views/panel/ContactusManagement'
import ScrollToTop from "./utility/ScrollToTop";
import 'swiper/swiper.min.css';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
import 'swiper/components/scrollbar/scrollbar.min.css';

// Route-based Manager
const Dashboard = lazy(() =>
    import("./views/panel/Dashboard")
);

// Route-based Web
const Web = lazy(() =>
    import("./views/web/home")
);
const Courses = lazy(() =>
    import("./views/web/courses")
);
const Achievements = lazy(() =>
    import("./views/web/achievements")
);
const Collaborators = lazy(() =>
    import("./views/web/collaborators")
);
const Licences = lazy(() =>
    import("./views/web/licences")
);
const Articles = lazy(() =>
    import("./views/web/articles")
);
const ArticlesCategory = lazy(() =>
    import("./views/web/articlesCategory")
);
const Article = lazy(() =>
    import("./views/web/article")
);
const Course = lazy(() =>
    import("./views/web/course")
);
const Payment = lazy(() =>
    import("./views/web/payment")
);
const Search = lazy(() =>
    import("./views/web/search")
);
const Shipping = lazy(() =>
    import("./views/web/shipping")
);
const AboutUs = lazy(() =>
    import("./views/web/aboutUs/about-us1")
);
const Rules = lazy(() =>
    import("./views/web/Rules")
);
const FaqsPage = lazy(() =>
    import("./views/web/FaqsPage")
);
const Contact_us = lazy(() =>
    import("./views/web/Contact_us")
);
const BeautyServices = lazy(() =>
    import("./views/web/beautyServices")
);
const gallery = lazy(() =>
    import("./views/web/gallery")
);
const CodeEditor = lazy(() =>
    import("./views/panel/CodeEditor")
);
const TopStudents = lazy(() =>
    import("./views/panel/TopStudents")
);

//panel
const CategoryCourses = lazy(() =>
    import("./views/panel/CategoryCourses")
);
const CategoryArticles = lazy(() =>
    import("./views/panel/CategoryArticles")
);
const Gallery = lazy(() =>
    import("./views/panel/AdminGallery")
);
const ContactUs = lazy(() =>
    import("./views/panel/ContactusManagement")
);
const Stories = lazy(() =>
    import("./views/panel/AdminStories")
);
const EducationalContent = lazy(() =>
    import("./views/panel/EducationalContent")
);
const EducationalUsers = lazy(() =>
    import("./views/panel/EducationalUsers")
);
const EducationalSliders = lazy(() =>
    import("./views/panel/EducationalSliders")
);
const EducationalHold = lazy(() =>
    import("./views/panel/EducationalHold")
);
const EducationalComments = lazy(() =>
    import("./views/panel/EducationalComments")
);
const EducationalSessions = lazy(() =>
    import("./views/panel/EducationalSessions")
);
const ArticleManagement = lazy(() =>
    import("./views/panel/ArticleManagement")
);

const CertificateManagement = lazy(() =>
    import("./views/panel/CertificateManagement")
);
const StudentManagement = lazy(() =>
    import("./views/panel/UserManagement")
);
const UsersBankCard = lazy(() =>
    import("./views/panel/UsersBankCard")
);
const PushNotification = lazy(() =>
    import("./views/panel/PushNotification")
);
const ChannelManagement = lazy(() =>
    import("./views/panel/ChannelManagement")
);
const ForumManagement = lazy(() =>
    import("./views/panel/ForumManagement")
);
const InvoiceManagement = lazy(() =>
    import("./views/panel/InvoicesManagement")
);
const MenuManagement = lazy(() =>
    import("./views/panel/MenuManagement/index")
);
const AppManagement = lazy(() =>
    import("./views/panel/AppManagement")
);
const WebSetting = lazy(() =>
    import("./views/panel/WebSetting")
);
const ExploreManagement = lazy(() =>
    import("./views/panel/ExploreManagement")
);
const CouponManagement = lazy(() =>
    import("./views/panel/CouponManagement")
);
const AuthManagement = lazy(() =>
    import("./views/panel/Authentication")
);
const PaymentConfirmation = lazy(() =>
    import("./views/panel/PaymentConfirmation")
);
const Profile = lazy(() =>
    import("./views/panel/Profile")
);
const FaqsPanel = lazy(() =>
    import("./views/panel/FaqsIndex")
);
const MyCourses = lazy(() =>
    import("./views/panel/MyCourses")
);
const MyInvoice = lazy(() =>
    import("./views/panel/MyInvoices")
);
const MyFavorite = lazy(() =>
    import("./views/panel/MyFavorite")
);
const TrackOrders = lazy(() =>
    import("./views/panel/TrackOrders")
);
const TeacherCourses = lazy(() =>
    import("./views/panel/TeacherCourses")
);

// Route-Auth
const Login = lazy(() =>
    import("./views/authentication/login/")
);
const Invoice = lazy(() =>
    import("./components/Panel/Invoice/Invoice")
);
const UserInvoice = lazy(() =>
    import("./components/Panel/Invoice/userInvoice")
);


const Label = lazy(() =>
    import("./components/Panel/Label")
);

//errors
const error404 = lazy(() =>
    import("./views/errors/404/index")
);

// Set Layout and Component Using App Route
const RouteConfig = ({component: Component, fullLayout, blankLayout, ...rest}) => (
    <Route
        {...rest}
        render={props => {
            return (
                <ContextLayout.Consumer>
                    {context => {
                        let LayoutTag =
                            blankLayout === true
                                ? context.blankLayout
                                : fullLayout === true
                                    ? context.fullLayout
                                    : context.state.activeLayout === "horizontal"
                                        ? context.horizontalLayout
                                        : context.VerticalLayout;
                        let view =
                            <LayoutTag {...props} >
                                <Suspense fallback={<Spinner/>}>
                                    <Component {...props} />
                                </Suspense>
                            </LayoutTag>;
                        if ((fullLayout === undefined && blankLayout === undefined) && Object.keys(rest.user).length === 0)
                            view = <Redirect to='/'/>;
                        return view;
                    }}
                </ContextLayout.Consumer>
            )
        }}
    />
)

const mapStateToProps = state => {
    return {
        user: state.auth
    }
}

const AppRoute = connect(mapStateToProps)(RouteConfig)

class AppRouter extends React.Component {
    componentWillMount() {
        let token = localStorage.getItem("token");
        if (token) {
            store.dispatch({
                type: "LOGIN",
                payload: token
            });
        }
        this.props.getPing();
        this.props.getUI();
    }

    componentWillUnmount() {

    }

    render() {
        return (
            <Router history={history}>
                <ScrollToTop/>
                <Switch>
                    {/* Web Route*/}
                    <AppRoute exact path="/" component={Web} fullLayout/>
                    <AppRoute exact path="/courses/:slug" component={Courses} fullLayout/>
                    <AppRoute exact path="/courses/online" component={Courses} fullLayout/>
                    <AppRoute exact path="/courses/offline" component={Courses} fullLayout/>
                    <AppRoute exact path="/courses/offer" component={Courses} fullLayout/>
                    <AppRoute exact path="/courses/vip-course" component={Courses} fullLayout/>
                    <AppRoute exact path="/courses/all" component={Courses} fullLayout/>
                    <AppRoute exact path="/courses/insite" component={Courses} fullLayout/>
                    <AppRoute exact path="/achievements" component={Achievements} fullLayout/>
                    <AppRoute exact path="/collaborators" component={Collaborators} fullLayout/>
                    <AppRoute exact path="/licences" component={Licences} fullLayout/>
                    <AppRoute exact path="/articles/:slug" component={Articles} fullLayout/>
                    <AppRoute exact path="/articles" component={ArticlesCategory} fullLayout/>
                    <AppRoute path="/article/:slug" component={Article} fullLayout/>
                    <AppRoute path="/article" component={Article} fullLayout/>
                    <AppRoute path="/course/:slug" component={Course} fullLayout/>
                    <AppRoute path="/course" component={Course} fullLayout/>
                    <AppRoute path="/payment" component={Payment} fullLayout/>
                    <AppRoute path="/search" component={Search} fullLayout/>
                    <AppRoute path="/shipping" component={Shipping} fullLayout/>
                    <AppRoute path="/about-us" component={AboutUs} fullLayout/>
                    <AppRoute path="/faqs" component={FaqsPage} fullLayout/>
                    <AppRoute path="/contact-us" component={Contact_us} fullLayout/>
                    <AppRoute path="/beauty-services" component={BeautyServices} fullLayout/>
                    <AppRoute path="/gallery" component={gallery} fullLayout/>
                    <AppRoute path="/Invoice/:slug" component={Invoice} blankLayout/>
                    <AppRoute path="/userInvoice/:slug" component={UserInvoice} blankLayout/>
                    <AppRoute path="/label/:slug" component={Label} fullLayout/>
                    <AppRoute path="/rules" component={Rules} fullLayout/>


                    <AppRoute path="/panel/dashboard" component={Dashboard}/>
                    <AppRoute path="/panel/category-courses" component={CategoryCourses}/>
                    <AppRoute path="/panel/category-articles" component={CategoryArticles}/>
                    <AppRoute path="/panel/gallery" component={Gallery}/>
                    <AppRoute path="/panel/stories" component={Stories}/>
                    <AppRoute path="/panel/faqs-panel" component={FaqsIndex}/>
                    <AppRoute path="/panel/contact-panel" component={ContactUs}/>
                    <AppRoute path="/panel/code_editor" component={CodeEditor}/>
                    <AppRoute path="/panel/top-students" component={TopStudents}/>

                    {/* Educational */}
                    <AppRoute path="/panel/educational-content" component={EducationalContent}/>
                    <AppRoute path="/panel/educational-content-users" component={EducationalUsers}/>
                    <AppRoute path="/panel/educational-content-sliders" component={EducationalSliders}/>
                    <AppRoute path="/panel/educational-content-hold" component={EducationalHold}/>
                    <AppRoute path="/panel/educational-content-comments" component={EducationalComments}/>
                    <AppRoute path="/panel/educational-content-sessions" component={EducationalSessions}/>
                    {/* End Educational */}
                    <AppRoute path="/panel/article-management" component={ArticleManagement}/>
                    <AppRoute path="/panel/certificate-management" component={CertificateManagement}/>
                    <AppRoute path="/panel/user-management" component={StudentManagement}/>
                    <AppRoute path="/panel/users-bank-card" component={UsersBankCard}/>
                    <AppRoute path="/panel/push-notification" component={PushNotification}/>
                    <AppRoute path="/panel/channel-management" component={ChannelManagement}/>
                    <AppRoute path="/panel/forum-management" component={ForumManagement}/>
                    <AppRoute path="/panel/invoices-management" component={InvoiceManagement}/>
                    <AppRoute path="/panel/menu-management" component={MenuManagement}/>
                    <AppRoute path="/panel/app-management" component={AppManagement}/>
                    <AppRoute path="/panel/web-setting" component={WebSetting}/>
                    <AppRoute path="/panel/explore-management" component={ExploreManagement}/>
                    <AppRoute path="/panel/coupon-management" component={CouponManagement}/>
                    <AppRoute path="/panel/auth-management" component={AuthManagement}/>
                    <AppRoute path="/panel/payment-confirmation" component={PaymentConfirmation}/>
                    <AppRoute path="/panel/profile" component={Profile}/>

                    {/* Teacher */}
                    <AppRoute path="/panel/teacher-courses" component={TeacherCourses}/>

                    {/* Student */}
                    <AppRoute path="/panel/my-courses" component={MyCourses}/>
                    <AppRoute path="/panel/my-invoices" component={MyInvoice}/>
                    <AppRoute path="/panel/my-favorite" component={MyFavorite}/>
                    <AppRoute path="/panel/track-order" component={TrackOrders}/>

                    <AppRoute component={error404} fullLayout/>
                </Switch>
            </Router>
        )
    }
}

export default connect(mapStateToProps, {getPing, getUI})(AppRouter);
